import type { DmResolvedNotification } from '../../../../services/dmNotifications';
import { formatDateTime, formatRelativeActivity } from '../../../../utils/dates';
import { NotificationLevelPill } from '../NotificationLevelPill';
import { notificationTitle } from '../notificationText';
import { notificationClosure, resolutionLabel, resolutionSuffix } from './resolvedNotificationText';

const SEPARATOR = ' · ';

interface ResolvedNotificationLineProps {
    notification: DmResolvedNotification;
}

function ResolvedMeta({ notification }: ResolvedNotificationLineProps) {
    const relative = formatRelativeActivity(notification.resolvedAt);
    const closure = notificationClosure(notification);
    const suffix = resolutionSuffix(closure);
    return (
        <p className="break-words text-xs leading-5 text-gray-400">
            {resolutionLabel(closure)}
            {relative && (
                <>
                    {SEPARATOR}
                    <time
                        dateTime={notification.resolvedAt}
                        title={formatDateTime(notification.resolvedAt)}
                        className="tabular-nums"
                    >
                        {relative}
                    </time>
                </>
            )}
            {suffix && `${SEPARATOR}${suffix}`}
        </p>
    );
}

export function ResolvedNotificationLine({ notification }: ResolvedNotificationLineProps) {
    return (
        <article className="flex flex-col gap-0.5 rounded-xl border border-gray-200 bg-gray-50 px-4 py-3">
            <div className="flex items-start gap-2">
                <p className="min-w-0 flex-1 break-words text-[12.5px] leading-5 text-gray-600">
                    {notificationTitle(notification)}
                </p>
                <span className="flex h-5 flex-shrink-0 items-center opacity-70">
                    <NotificationLevelPill level={notification.level} />
                </span>
            </div>
            <ResolvedMeta notification={notification} />
        </article>
    );
}
